import { useState } from 'react';
import html2canvas from 'html2canvas';

const usePngFromRecharts = () => {
  const [refNode, setRefNode] = useState<any>(null);
  const ref = (node: any) => {
    setRefNode(node);
  };

  const handleDownload = async () => {
    const container = refNode?.container as HTMLElement | null | undefined;
    if (!container) {
      return null;
    }

    const { width, height } = container.getBoundingClientRect();
    const data = await html2canvas(container).then((canvas) =>
      canvas.toDataURL('image/png', 1.0),
    );

    return {
      data,
      width,
      height,
    };
  };

  return { ref, handleDownload };
};

export default usePngFromRecharts;
